import { defineStore } from "pinia";
import { geolocationMixin } from "~/mixins/geolocationMixin.js";

const getLocationAndCall = geolocationMixin.methods.getLocationAndCall;
const { trackEvent } = useEventTracker("countly");

export const useAuthStore = defineStore({
  id: "auth",
  state: () => ({
    loadingLogin: false,
    snackbar: false,
    messageSnack: "-",
    snackStatus: "-",
    snackLocation: "top-center",
    snackTimeout: 2000,
    isRevamp: false,
  }),
  getters: {
    isAuthorized() {
      const lsToken = localStorage.getItem("tokenBelajarWajib");
      return !!lsToken && lsToken !== "undefined";
    },
  },
  actions: {
    getBelajarWajibBaseUrl() {
      const config = useRuntimeConfig();
      const configuredBase = (config?.public?.apiBelajarWajib || "").trim();
      if (configuredBase) {
        return configuredBase.replace(/\/+$/, "");
      }

      if (typeof window !== "undefined") {
        const host = window.location.hostname;
        if (host.includes("dev-sibangkom") || host.includes("stg")) {
          return "https://dev-sibangkom-mandiri.lan.go.id";
        }
      }

      return "https://sibangkom-mandiri.lan.go.id";
    },
    async login(payload, isFromRevamp = false) {
      let stateTracker = "";
      this.loadingLogin = true;
      const baseUrl = this.getBelajarWajibBaseUrl();
      try {
        const response = await $fetch.raw(`${baseUrl}/sibangkom-auth/login`, {
          method: "POST",
          body: payload,
        });
        const data = response?._data || {};
        useAuthStore().setTokens(data.data);
        useAuthStore().$patch({
          snackStatus: "positive",
          snackbar: true,
          messageSnack: response?._data?.message,
          isRevamp: true,
        });
        stateTracker = "success";
        const redirectPath = localStorage.getItem("redirectAfterLogin");
        if (redirectPath) {
          localStorage.removeItem("redirectAfterLogin");
          return navigateTo(redirectPath, { external: true });
        }
        return setTimeout(() => {
          navigateTo(`${isFromRevamp ? "/revamp" : ""}/portal-pembelajaran`, {
            external: true,
          });
        }, 800);
      } catch (error) {
        stateTracker = "failed";
        const d = error?.response?._data;
        useAuthStore().$patch({
          snackStatus: "destructive",
          snackbar: true,
          messageSnack: d?.error || d?.message || "Login gagal!",
          isRevamp: true,
        });
        useAuthStore().clearTokens();
      } finally {
        getLocationAndCall((lat, long) => {
          trackEvent({
            key: "login",
            count: 1,
            segmentation: {
              location: `${lat}, ${long}`,
              state: stateTracker,
              triggerLocation: "btn_masuk",
              page: "login",
              nip: payload?.username || "unknown",
            },
          });
        });
        this.loadingLogin = false;
      }
    },
    loginWithBssn() {
      if (useToggleCheck("GENERAL", true)) {
        navigateTo(
          `${/revamp/.test(useRoute().path) ? "/revamp" : ""}/login`,
          { external: true },
        );
        return;
      }

      const config = useRuntimeConfig();
      const url = config?.public?.bssnSsoUrl;
      if (url) {
        window.location.href = url;
      } else {
        useAuthStore().$patch({
          snackStatus: "destructive",
          snackbar: true,
          messageSnack: "Konfigurasi SSO BSSN belum diatur.",
          isRevamp: true,
        });
      }
      getLocationAndCall((lat, long) => {
        trackEvent({
          key: "login",
          count: 1,
          segmentation: {
            location: `${lat}, ${long}`,
            triggerLocation: "connect_idn",
            page: "login",
          },
        });
      });
    },
    setTokens(data) {
      const accessToken = data.jwttoken;
      const refreshToken = data.refreshToken;
      localStorage.setItem("tokenBelajarWajib", accessToken);
      localStorage.setItem("refreshTokenBelajarWajib", refreshToken);
    },
    clearTokens() {
      localStorage.removeItem("tokenBelajarWajib");
      localStorage.removeItem("refreshTokenBelajarWajib");
      localStorage.removeItem("courseType");
      localStorage.removeItem("courseList");
      localStorage.removeItem("dataPegawai");
      localStorage.removeItem("profile");
    },
  },
});
